
import * as React from 'react';

import { Notification } from 'app/shared/components/spb/notification/notification';
import { TextParag } from 'app/shared/components/common/text-style/text-parag';

import './style.scss';

export interface ISellerSpace {
    textTitle?: any;
    smallText?: any;
      size?: any;
      icon?: any;
      colorText?: any;
    }


export const SellerSpace = ({ textTitle, smallText, icon, size = 'D',colorText='#4e4e4e' }: ISellerSpace) => {
    return (
        <div className="notifcation">
        <TextParag  textTitle ={textTitle}  smallText= {smallText} icon={icon} size={size} />
        <Notification />
       </div>
    );
};
export default SellerSpace
